<div *ngIf="question" class="ranking-example-list" cdkDropList (cdkDropListDropped)="drop($event)">
  <div class="ranking-example-box" *ngFor="let rank of ranks" cdkDrag>
    <div *ngIf="!rank.isOther">
      <span [innerHTML]="rank.label"></span>
    </div>
    <diy-data *ngIf="rank.isOther" #data [preview]="false" [question]="rank.other"></diy-data>
    <div class="ranking-drag-handle" cdkDragHandle>
      <mat-icon>drag_indicator</mat-icon>
    </div>
  </div>
</div>
